import React, { useEffect, useState } from "react"
import axios from "axios"
import { Card, CardBody, CardImg, Input, Spinner, Row } from "reactstrap"
import Spinners from "components/Common/Spinner"
import { toast, ToastContainer } from "react-toastify"
import img1 from "../../../common/NoAvatar.png"
import { replaceS3Url } from "components/Common/ReplaceS3Url"
import { OtherDetails } from "./OtherDeatis"
import { ReusableComponent } from "./ResubaleComponentCustom"

const ReusableComponent10 = ({
  ProfilePic,
  tablename,
  bucketName,
  setSubmitted,
  details,
}) => {
  const [avatar12, setAvatar12] = useState()
  const [loading, setLoading] = useState(false)

  const handleFileChange = e => {
    const file = e.target.files[0]
    if (file) {
      console.log("Selected file:", file)
      setAvatar12(file)
    }
  }

  const handleImageSubmit = async e => {
    e.preventDefault()
    let formData = new FormData()
    formData.append("sid", localStorage.getItem("sid").replace(/"/g, ""))
    formData.append("user_id", localStorage.getItem("user_id"))
    formData.append("tablename", tablename)
    formData.append("bucketName", bucketName)
    formData.append("profile", "app_avatar")
    // formData.append("image", image);
    formData.append("image", avatar12)

    setSubmitted(false)
    setLoading(true)
    await axios({
      method: "POST",
      url: `https://marcopolo.prisms.in/api/information/changepic`,
      data: formData,
      headers: {
        Authorization: "#$laksdfnlknoea#$@$%^&%$",
        "Content-Type": "multipart/form-data",
        "Access-Control-Allow-Origin": "*",
      },
    })
      .then(response => {
        setAvatar12(null)
        setLoading(false)
        setSubmitted(true)
        toast.success("Profile Successfully updated")
      })
      .catch(error => {
        console.log(error)
        setLoading(false)

        setSubmitted(true)
      })
  }
  return (
    <div className="mb-3 mt-4">
      {Object.entries(details).map(([key, value]) => (
        <div
          className="d-flex align-items-start justify-content-between mt-5"
          key={key}
        >
          <div className="w-50">
            <span
              style={{
                lineHeight: 2,
                fontSize: "14px",
                fontWeight: 600,
              }}
            >
              {key}
            </span>
          </div>
          {loading ? (
            <Spinner />
          ) : (
            <div className="w-50">
              <div className="position-relative">
                <CardImg
                  src={
                    avatar12
                      ? URL.createObjectURL(avatar12)
                      : value
                      ? value
                      : img1
                  }
                  alt="Profile"
                  className="rounded-circle"
                  style={{
                    width: "120px",
                    height: "120px",
                    marginLeft: "13px",
                    objectFit: "cover",
                    border: "4px solid #ccc",
                  }}
                />
                {ProfilePic && ProfilePic[0].editable_by_parents === 1 ? (
                  <>
                    <Input
                      type="file"
                      accept="image/png, image/jpeg, image/jpg"
                      style={{ display: "none" }}
                      id="file-input-12"
                      onChange={handleFileChange}
                    />
                    <label
                      htmlFor="file-input-12"
                      style={{
                        position: "absolute",
                        bottom: 0,
                        left: "91px",
                        backgroundColor: "#007bff",
                        color: "white",
                        padding: "5px",
                        borderRadius: "50%",
                        cursor: "pointer",
                        border: "2px solid white",
                      }}
                    >
                      <i
                        className="fa fa-camera"
                        style={{ fontSize: "18px" }}
                      />
                    </label>
                  </>
                ) : null}
              </div>
              {avatar12 ? (
                <div className="d-flex flex-column">
                  <button
                    className="btn btn-outline-primary mt-3"
                    onClick={handleImageSubmit}
                  >
                    Upload
                  </button>
                </div>
              ) : null}
            </div>
          )}
        </div>
      ))}
    </div>
  )
}
const ReusableComponent2 = ({
  ProfilePic,
  tablename,
  bucketName,
  setSubmitted,
  details,
}) => {
  const [avatar, setAvatar] = useState()
  const [loading, setLoading] = useState(false)

  const handleFileChange = e => {
    const file = e.target.files[0]
    if (file) {
      console.log("Selected file:", file)
      setAvatar(file)
    }
  }

  const handleImageSubmit = async e => {
    e.preventDefault()
    let formData = new FormData()
    formData.append("sid", localStorage.getItem("sid").replace(/"/g, ""))
    formData.append("user_id", localStorage.getItem("user_id"))
    formData.append("tablename", tablename)
    formData.append("bucketName", bucketName)
    formData.append("profile", "app_avatar_father")
    // formData.append("image", image);
    formData.append("image", avatar)

    setSubmitted(false)
    setLoading(true)
    await axios({
      method: "POST",
      url: `https://marcopolo.prisms.in/api/information/changepic`,
      data: formData,
      headers: {
        Authorization: "#$laksdfnlknoea#$@$%^&%$",
        "Content-Type": "multipart/form-data",
        "Access-Control-Allow-Origin": "*",
      },
    })
      .then(response => {
        setAvatar(null)
        setLoading(false)
        setSubmitted(true)
        toast.success("Profile Successfully updated")
      })
      .catch(error => {
        setLoading(false)
        setSubmitted(false)
      })
  }

  return (
    <div className="mb-3 mt-4">
      {Object.entries(details).map(([key, value]) => (
        <div
          className="d-flex align-items-start justify-content-between mt-5"
          key={key}
        >
          <div className="w-50">
            <span
              style={{
                lineHeight: 2,
                fontSize: "14px",
                fontWeight: 600,
              }}
            >
              {key}
            </span>
          </div>
          {loading ? (
            <Spinner />
          ) : (
            <div className="w-50">
              <div className="position-relative">
                <CardImg
                  src={avatar ? URL.createObjectURL(avatar) : value || img1}
                  alt="Profile"
                  className="rounded-circle"
                  style={{
                    width: "120px",
                    height: "120px",
                    marginLeft: "13px",
                    objectFit: "cover",
                    border: "4px solid #ccc",
                  }}
                />
                {ProfilePic && ProfilePic[1].editable_by_parents === 1 ? (
                  <>
                    {" "}
                    <Input
                      type="file"
                      accept="image/png, image/jpeg, image/jpg"
                      style={{ display: "none" }}
                      id="file-input"
                      onChange={handleFileChange}
                    />
                    <label
                      htmlFor="file-input"
                      style={{
                        position: "absolute",
                        bottom: 0,
                        left: "91px",
                        backgroundColor: "#007bff",
                        color: "white",
                        padding: "5px",
                        borderRadius: "50%",
                        cursor: "pointer",
                        border: "2px solid white",
                      }}
                    >
                      <i
                        className="fa fa-camera"
                        style={{ fontSize: "18px" }}
                      />
                    </label>
                  </>
                ) : null}
              </div>
              {avatar ? (
                <div className="d-flex flex-column">
                  <button
                    className="btn btn-outline-primary mt-3"
                    onClick={handleImageSubmit}
                  >
                    Upload
                  </button>
                </div>
              ) : null}
            </div>
          )}
        </div>
      ))}
    </div>
  )
}

const ReusableComponent3 = ({
  ProfilePic,
  title,
  tablename,
  profile,
  bucketName,
  setSubmitted,
  details,
}) => {
  const [avatar1, setAvatar1] = useState()
  const [loading, setLoading] = useState(false)

  const handleFileChange1 = e => {
    const file = e.target.files[0]
    if (file) {
      console.log("Selected file:", file)
      setAvatar1(file)
    }
  }

  const handleImageSubmit = async e => {
    e.preventDefault()
    let formData = new FormData()
    formData.append("sid", localStorage.getItem("sid").replace(/"/g, ""))
    formData.append("user_id", localStorage.getItem("user_id"))
    formData.append("tablename", tablename)
    formData.append("bucketName", bucketName)
    formData.append("profile", "app_avatar_mother")
    // formData.append("image", image);
    formData.append("image", avatar1)
    setSubmitted(false)
    setLoading(true)

    await axios({
      method: "POST",
      url: `https://marcopolo.prisms.in/api/information/changepic`,
      data: formData,
      headers: {
        Authorization: "#$laksdfnlknoea#$@$%^&%$",
        "Content-Type": "multipart/form-data",
        "Access-Control-Allow-Origin": "*",
      },
    })
      .then(response => {
        setAvatar1(null)
        setLoading(false)
        setSubmitted(true)
        toast.success("Profile Successfully updated")
      })
      .catch(error => {
        setLoading(false)
        setSubmitted(true)
      })
  }
  return (
    <div className="mb-3 mt-4">
      {Object.entries(details).map(([key, value]) => (
        <div
          className="d-flex align-items-start justify-content-between mt-5"
          key={key}
        >
          <div className="w-50">
            <span
              style={{
                lineHeight: 2,
                fontSize: "14px",
                fontWeight: 600,
              }}
            >
              {key}
            </span>
          </div>
          {loading ? (
            <Spinner />
          ) : (
            <div className="w-50">
              <div className="position-relative">
                <CardImg
                  src={avatar1 ? URL.createObjectURL(avatar1) : value || img1}
                  alt="Profile"
                  className="rounded-circle"
                  style={{
                    width: "120px",
                    height: "120px",
                    marginLeft: "13px",
                    objectFit: "cover",
                    border: "4px solid #ccc",
                  }}
                />
                {ProfilePic && ProfilePic[2].editable_by_parents === 1 ? (
                  <>
                    {" "}
                    <Input
                      type="file"
                      accept="image/png, image/jpeg, image/jpg"
                      style={{ display: "none" }}
                      id="file-input-2"
                      onChange={handleFileChange1}
                    />
                    <label
                      htmlFor="file-input-2"
                      style={{
                        position: "absolute",
                        bottom: 0,
                        left: "91px",
                        backgroundColor: "#007bff",
                        color: "white",
                        padding: "5px",
                        borderRadius: "50%",
                        cursor: "pointer",
                        border: "2px solid white",
                      }}
                    >
                      <i
                        className="fa fa-camera"
                        style={{ fontSize: "18px" }}
                      />
                    </label>
                  </>
                ) : null}
              </div>
              {avatar1 ? (
                <div className="d-flex flex-column">
                  <button
                    className="btn btn-outline-primary mt-3"
                    onClick={handleImageSubmit}
                  >
                    Upload
                  </button>
                </div>
              ) : null}
            </div>
          )}
        </div>
      ))}
    </div>
  )
}

const ReusableComponent4 = ({
  ProfilePic,
  title,
  tablename,
  profile,
  bucketName,
  setSubmitted,
  details,
}) => {
  const [avatar1, setAvatar1] = useState()
  const [loading, setLoading] = useState(false)

  const handleFileChange4 = e => {
    const file = e.target.files[0]
    if (file) {
      console.log("Selected file:", file)
      setAvatar1(file)
    }
  }

  const handleImageSubmit = async e => {
    e.preventDefault()
    let formData = new FormData()
    formData.append("sid", localStorage.getItem("sid").replace(/"/g, ""))
    formData.append("user_id", localStorage.getItem("user_id"))
    formData.append("tablename", tablename)
    formData.append("bucketName", bucketName)
    formData.append("profile", "avatar_guardian")
    // formData.append("image", image);
    formData.append("image", avatar1)
    setSubmitted(false)
    setLoading(true)

    await axios({
      method: "POST",
      url: `https://marcopolo.prisms.in/api/information/changepic`,
      data: formData,
      headers: {
        Authorization: "#$laksdfnlknoea#$@$%^&%$",
        "Content-Type": "multipart/form-data",
        "Access-Control-Allow-Origin": "*",
      },
    })
      .then(response => {
        setAvatar1(null)
        setLoading(false)
        setSubmitted(true)
        toast.success("Profile Successfully updated")
      })
      .catch(error => {
        setLoading(false)
        setSubmitted(true)
      })
  }
  return (
    <div className="mb-3 mt-4">
      {Object.entries(details).map(([key, value]) => (
        <div
          className="d-flex align-items-start justify-content-between mt-5"
          key={key}
        >
          <div className="w-50">
            <span
              style={{
                lineHeight: 2,
                fontSize: "14px",
                fontWeight: 600,
              }}
            >
              {key}
            </span>
          </div>
          {loading ? (
            <Spinner />
          ) : (
            <div className="w-50">
              <div className="position-relative">
                <CardImg
                  src={avatar1 ? URL.createObjectURL(avatar1) : value || img1}
                  alt="Profile"
                  className="rounded-circle"
                  style={{
                    width: "120px",
                    height: "120px",
                    marginLeft: "13px",
                    objectFit: "cover",
                    border: "4px solid #ccc",
                  }}
                />
                <>
                  <Input
                    type="file"
                    accept="image/png, image/jpeg, image/jpg"
                    style={{ display: "none" }}
                    id="file-input-3"
                    onChange={handleFileChange4}
                  />
                  <label
                    htmlFor="file-input-3"
                    style={{
                      position: "absolute",
                      bottom: 0,
                      left: "91px",
                      backgroundColor: "#007bff",
                      color: "white",
                      padding: "5px",
                      borderRadius: "50%",
                      cursor: "pointer",
                      border: "2px solid white",
                    }}
                  >
                    <i className="fa fa-camera" style={{ fontSize: "18px" }} />
                  </label>
                </>
              </div>
              {avatar1 ? (
                <div className="d-flex flex-column">
                  <button
                    className="btn btn-outline-primary mt-3"
                    onClick={handleImageSubmit}
                  >
                    Upload
                  </button>
                </div>
              ) : null}
            </div>
          )}
        </div>
      ))}
    </div>
  )
}

const Home = () => {
  const [submitted, setSubmitted] = useState(false)
  const token = JSON.parse(localStorage.getItem("Token"))
  const [profileData, setProfileData] = useState([])
  const [loading, setLoading] = useState(true)
  const [customField, setCustomFields] = useState()
  const [error, setError] = useState(null)
  const [schoolName, setSchoolName] = useState()
  const [batch, setBacth] = useState()
  const [currentAcadId, setCurrentAcadId] = useState(null)
  const [customEditField, setCustomEditField] = useState()

  const live_Url = "https://marcopolo.prisms.in"

  useEffect(() => {
    const getStudentProfile = async () => {
      try {
        const res = await axios({
          method: "POST",
          data: {
            sid: localStorage.getItem("sid").replace(/"/g, ""),
            userid: localStorage.getItem("user_id"),
          },
          url: "https://marcopolo.prisms.in/api/studentProfile/data",
        })

        setProfileData(res.data)
        setLoading(false)
      } catch (error) {
        setError("Failed to load profile data. Please try again.")
        setLoading(false)
      }
    }

    const getParentEditableInfo = async () => {
      try {
        await axios({
          method: "POST",
          url: "https://marcopolo.prisms.in/api/StudentProfilePic/get-dynamic-field",
          data: {
            acad_id: localStorage.getItem("acad_id"),
          },
          headers: {
            Authorization: token,
          },
        }).then(res => {
          // console.log(res.data.data)
          // console.log(res.data.data)
          setCustomFields(res.data.data)
        })

        // setProfileData(res.data)
        // setLoading(false)
      } catch (error) {
        setError("Failed to load profile data. Please try again.")
        // setLoading(false)
      }
    }

    const getCustomEditField = async () => {
      try {
        //https://marcopolo.prisms.in/api/StudentProfilePic/get-editable-field
        await axios({
          method: "POST",
          url: "https://marcopolo.prisms.in/api/StudentProfilePic/get-editable-field",
          data: {
            acad_id: localStorage.getItem("acad_id"),
          },
          headers: {
            Authorization: token,
          },
        }).then(res => {
          // console.log(res.data.data)
          // console.log(res.data.data)
          setCustomEditField(res.data.data)
        })
      } catch (error) {}
    }

    const getSchoolName = async () => {
      const data = {
        fun_name: "getSchoolURL",
        sid: localStorage.getItem("sid").replace(/"/g, ""),
      }
      await axios({
        method: "POST",
        url: "https://topschool.prisms.in/rest/index.php/user_list.json",
        data,
      }).then(response => {
        // console.log(response.data)
        setSchoolName(response.data)
      })
    }
    getCustomEditField()
    getStudentProfile()
    getSchoolName()
    getParentEditableInfo()
  }, [token, submitted])

  useEffect(() => {
    const getAcadId = async () => {
      try {
        const response = await axios({
          method: "GET",
          url: `${live_Url}/api/tscommon/getUserAcadID`,
          headers: {
            Authorization: token,
          },
        })
        setBacth(response.data.acadId.academics)

        setCurrentAcadId(response.data.acadId.acad_id)
      } catch (error) {
        console.error("Error fetching data:", error)
      }
    }

    getAcadId()
  }, [token])

  const ProfilePic =
    customEditField &&
    customEditField.filter(field => field.field_name.startsWith("upload_icon"))

  const guardianAvatar =
    customEditField &&
    customEditField.filter(field =>
      field.field_title.startsWith("Guardian's Photo")
    )
  return (
    <Row className="mb-5">
      {loading && <Spinners />}
      {error && <div className="alert alert-danger">{error}</div>}

      {!loading && !error && profileData.length > 0 ? (
        <Card className="shadow-lg mx-auto mt-5" style={{ maxWidth: "900px" }}>
          <CardBody>
            <div className="text-center mb-3 mt-3">
              <CardImg
                src={
                  profileData[0].avatar
                    ? replaceS3Url(profileData[0].avatar)
                    : null || img1
                }
                alt="Profile"
                className="rounded-circle"
                style={{ width: "120px", height: "120px", objectFit: "cover" }}
              />
              <h5 className="text-center text-dark mt-4">
                {profileData && profileData[0].Student_name}
              </h5>
            </div>
            <ReusableComponent
              title="General Details"
              details={{
                Name: profileData[0].Student_name,
                Username: profileData[0].username,
                ...(profileData[0].house_details && {
                  House: profileData[0].house_details,
                }),
                Class: profileData[0].class_name,
                Batch: batch,
              }}
            />
            {customField && customField.length > 0 ? (
              <OtherDetails title={"Other Details"} data={customField} />
            ) : null}

            <ReusableComponent
              customEditField={customEditField}
              title="Personal Details"
              details={{}}
              setSubmitted={setSubmitted}
              data={customField}
            />

            <ReusableComponent10
              ProfilePic={ProfilePic}
              details={{
                "Student Pic": profileData[0].avatar,
              }}
              profile={"student"}
              bucketName={`topschool-attachments/${schoolName}prisms/${currentAcadId}/studentProfile/student`}
              tablename={"k6kb9_pri_students_static_info"}
              setSubmitted={setSubmitted}
            />
            <ReusableComponent2
              ProfilePic={ProfilePic}
              details={{
                "Father's Pic": replaceS3Url(profileData[0].app_avatar_father),
              }}
              profile={"father"}
              bucketName={`topschool-attachments/${schoolName}prisms/${currentAcadId}/studentProfile/father`}
              tablename={"k6kb9_pri_parents_info"}
              setSubmitted={setSubmitted}
            />
            <ReusableComponent3
              ProfilePic={ProfilePic}
              details={{
                "Mother's Pic": replaceS3Url(profileData[0].app_avatar_mother),
              }}
              profile={"mother"}
              bucketName={`topschool-attachments/${schoolName}prisms/${currentAcadId}/studentProfile/mother`}
              tablename={"k6kb9_pri_parents_info"}
              setSubmitted={setSubmitted}
            />

            {guardianAvatar &&
              guardianAvatar.length > 0 &&
              guardianAvatar[0].editable_by_parents == "1" && (
                <>
                  <ReusableComponent4
                    ProfilePic={ProfilePic}
                    details={{
                      "Guardian's Pic": replaceS3Url(
                        profileData[0].avatar_guardian
                      ),
                    }}
                    profile={"avatar_guardian"}
                    bucketName={`topschool-attachments/${schoolName}prisms/${currentAcadId}/studentProfile/guardian`}
                    tablename={"k6kb9_pri_parents_info"}
                    setSubmitted={setSubmitted}
                  />
                  <div className="mt-3 mb-3 fw-medium">
                    <span className="mt-3 mb-3 fw-medium text-danger">
                      <strong className="text-dark fs-5">Note : </strong>{" "}
                      Profile Pic should be clear, properly sized, and present
                      your face accurately. It should be a color photo, with the
                      head centered and the face taking up at least 70% of the
                      frame.{" "}
                    </span>
                  </div>
                </>
              )}
          </CardBody>
        </Card>
      ) : (
        <Card>
          <CardBody className="text-center">
            <span className="text-center fs-4"></span>
          </CardBody>
        </Card>
      )}
      <ToastContainer />
    </Row>
  )
}

export default Home
